export enum TaskTimeShiftAssignmentType {
  DRAFT = 'DRAFT',
  REAL_SHIFT = 'REAL_SHIFT',
}
